module.exports = __webpack_public_path__ + "img/typetosee.ddecec6a.png";